// extracted by mini-css-extract-plugin
export default {"cardextra__btn":"extracard_cardextra__btn__GJJa5","cardextra":"extracard_cardextra__2m7H4"};